var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeshape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    gradientTransform: "rotate(90.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF45A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF6A6A"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9955 20.3729C12.1143 20.3729 12.2479 20.3373 12.3963 20.2661C12.5507 20.1948 12.6962 20.1146 12.8328 20.0256C14.4953 18.9568 15.9352 17.8346 17.1524 16.6589C18.3756 15.4833 19.3226 14.272 19.9936 13.0251C20.6645 11.7782 21 10.5224 21 9.25764C21 8.43825 20.8664 7.6901 20.5992 7.01321C20.338 6.33038 19.9758 5.74255 19.5126 5.24972C19.0495 4.7569 18.5092 4.37689 17.8916 4.1097C17.2741 3.83656 16.6091 3.7 15.8966 3.7C15.0119 3.7 14.24 3.92563 13.5809 4.37689C12.9278 4.82221 12.3993 5.41004 11.9955 6.14037C11.6037 5.41598 11.0782 4.82815 10.4191 4.37689C9.76002 3.92563 8.98812 3.7 8.10341 3.7C7.3909 3.7 6.72588 3.83656 6.10836 4.1097C5.49678 4.37689 4.95646 4.7569 4.48738 5.24972C4.02425 5.74255 3.65908 6.33038 3.39189 7.01321C3.13063 7.6901 3 8.43825 3 9.25764C3 10.5224 3.33251 11.7782 3.99753 13.0251C4.66848 14.272 5.61554 15.4833 6.83869 16.6589C8.06779 17.8346 9.51361 18.9568 11.1762 20.0256C11.3068 20.1146 11.4493 20.1948 11.6037 20.2661C11.758 20.3373 11.8887 20.3729 11.9955 20.3729Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeshape);
export default __webpack_public_path__ + "static/media/like.shape.c9ff92e3cd34bf7954726b2c9b8fb12a.svg";
export { ForwardRef as ReactComponent };